import { render, staticRenderFns } from "./DocumentsProcessor.vue?vue&type=template&id=eae1e50c&"
import script from "./DocumentsProcessor.vue?vue&type=script&lang=ts&"
export * from "./DocumentsProcessor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports